/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useLazyQuery } from '@apollo/client';
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '../../../atoms/TextField';
import { CITIES_QUERY } from '../../../../apollo/queries';

// ...

const CitiesAutocomplete = ({
  defaultValue,
  onChange,
  handleInputChange,
  id,
  name,
  variant,
  label,
  getOptionLabel,
  inputProps,
  error,
  helperText,
  ...props
}) => {
  const [cityInput, setCityInput] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([{ ...defaultValue }]);

  const handleCompleteFetchCities = (citiesData) => {
    if (citiesData && citiesData.filterCities && citiesData.filterCities[0]) {
      setOptions(citiesData.filterCities ? [...citiesData.filterCities] : []);
    }
  };

  const [fetchCities, { loading: citiesLoading }] = useLazyQuery(CITIES_QUERY, {
    variables: { query: cityInput },
    onCompleted: handleCompleteFetchCities,
  });

  React.useEffect(() => {
    if (cityInput) {
      fetchCities();
    }
  }, [cityInput]);

  const handleChange = (event, value) => {
    onChange(value);
  };

  return (
    <Autocomplete
      onChange={handleChange}
      onInputChange={handleInputChange}
      id={id}
      name={name}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, val) => option.name === val.name}
      getOptionLabel={(option) =>{
        if(option.country) {
          return `${option.name}, ${option.country.name}`;
        }
        return option.name ?? ""
      }}
      options={options}
      loading={citiesLoading}
      defaultValue={defaultValue}
      renderInput={(params) => (
        <TextField
          {...inputProps}
          error={error}
          helperText={helperText}
          {...params}
          label={label}
          fullWidth
          variant={variant}
          onChange={(e) => setCityInput(e.target.value)}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {citiesLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      {...props}
    />
  );
};

// ...


CitiesAutocomplete.propTypes = {
  onChange: PropTypes.func,
  handleOnChange: PropTypes.func,
  handleInputChange: PropTypes.func,
};

CitiesAutocomplete.defaultProps = {
  onChange: () => {},
  handleOnChange: () => {},
  handleInputChange: () => {},
};

export default CitiesAutocomplete;
